import React  from "react";
import {
    Modal,
    Button, 
} from "react-bootstrap";

export default function GenericModal (props) {
    let title;
    let body;
    // console.log(props)
    let show = props.show;
    const handleClose = () => props.setShow(false);
    if (props.success){
        title = "Success!";
        body = 'Your action was successful.';
    } else {
        title = "Woops!";
        body = 'Something went wrong';
    }
   
    return (
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
